module.exports = __webpack_public_path__ + "static/img/AdvancedTorsoDesign4.81c45fe4.jpg";